<template>
  <div>
    <p class="subtitle-2 mb-1">Scheduled outputs</p>
    <p class="caption text--secondary mb-2">
      At event start (including pre-roll), the device turns these outputs <strong>on</strong>
      (even if already on). At event end (including post-roll), it turns them
      <strong>off</strong> (even if already off).
    </p>

    <v-progress-linear v-if="loading" indeterminate color="primary" class="mb-2" />

    <v-alert v-else-if="!rows.length" dense outlined type="info">
      {{ fallbackMessage }}
    </v-alert>

    <v-simple-table v-else dense>
      <thead>
        <tr>
          <th>Name / ID</th>
          <th>Type</th>
          <th>Resolution</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in rows" :key="row.id">
          <td>{{ row.name }} <span class="text--secondary">(ID {{ row.id }})</span></td>
          <td>{{ row.type }}</td>
          <td>{{ row.resolution }}</td>
        </tr>
      </tbody>
    </v-simple-table>
  </div>
</template>

<script>
export default {
  name: 'SchedulerEventOutputs',

  props: {
    event: { type: Object, required: true },
  },

  data() {
    return {
      loading: false,
      rows: [],
    }
  },

  computed: {
    fallbackMessage() {
      const ids = (this.event.output_ids || []).join(', ')
      if (ids) {
        return 'Output details unavailable (IDs: ' + ids + '). Open the device page to refresh configuration.'
      }
      return 'No outputs selected for this event.'
    },
  },

  watch: {
    'event.device_guid': {
      immediate: true,
      handler() {
        this.loadRows()
      },
    },
    'event.output_ids': {
      deep: true,
      handler() {
        this.loadRows()
      },
    },
  },

  methods: {
    loadRows() {
      const ids = this.event.output_ids || []
      if (!this.event.device_guid || !ids.length) {
        this.rows = []
        return
      }

      this.loading = true
      const device = this.$devices.getDevice(this.event.device_guid)
      if (!device || device.device_type !== 'encoder') {
        this.rows = ids.map((id) => ({
          id,
          name: 'Output #' + id,
          type: '—',
          resolution: '—',
        }))
        this.loading = false
        return
      }

      device.syncDocuments()
      const all = this.$helpers.schedulerOutputChoices(device)
      const byId = {}
      for (const row of all) {
        byId[row.id] = row
      }

      this.rows = ids.map((id) => {
        if (byId[id]) {
          return byId[id]
        }
        return {
          id,
          name: 'Output #' + id,
          type: 'Unknown',
          resolution: '—',
        }
      })
      this.loading = false
    },
  },
}
</script>
